export class DeleteTrainingsRequest {
    ids: number[];

    constructor(ids: number[]) {
        this.ids = ids;
    }
}
